import template from './status.html'
import './status.css'

export default {
  template,
  controller: 'statusController as status'
}
